// api endpoint
const host = "http://v21api.lpm.mx/";

export default host;